import { useMediaQuery } from '@mui/material';
import { ReactComponent as Background } from './header_menu_hover.svg';
import { ReactComponent as ArrowRightMobile } from './arrow-right-mobile.svg';
import style from './style.module.scss';
import { useRef, useState, useEffect, useCallback } from 'react';
import clsx from 'clsx';

const background_width = 98;

export const ItemMenu = ({ item, blockUserAccess = false }) => {
    const background = useRef(null);
    const link = useRef(null);
    const [active, setActive] = useState(false);
    const isLaptop = useMediaQuery(`(max-width : ${style.headerBreakpoint})`);

    const addScale = (item) => {
        const width = item.offsetWidth;
        const scale = width / background_width;
        background.current.style.transform = `scaleX(${scale})`;
    };

    const handleMouseEnter = useCallback(
        (e) => {
            if (!active) {
                addScale(e.currentTarget);
            }
        },
        [active],
    );

    const handleMouseLeave = useCallback(() => {
        if (!active) {
            background.current.style.transform = 'scaleX(0.1)';
        }
    }, [active]);

    useEffect(() => {
        const isActive = window.location.href.startsWith(item.url);
        setActive(isActive);
        addScale(link.current);
    }, [item.url]);

    const handleOpenPopinSignupEvent = () => {
        if (blockUserAccess) {
            // Fire the event "openPopinSignup"
            document.dispatchEvent(new CustomEvent('openPopinSignup', { detail: { openModal: true } }));
        }
    };

    return (
        <a
            href={item.url === '#' || blockUserAccess ? '#userNotConnected' : item.url}
            className={clsx(style.menuItemUrl, active ? style.active : undefined)}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleOpenPopinSignupEvent}
            ref={link}
        >
            <Background className={style.background} ref={background} />
            <span>{item.title}</span>
            {isLaptop && <ArrowRightMobile />}
        </a>
    );
};
